import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * Sub-Menu Item Component
 * Represents a sub-menu item (no icon, indented)
 * Memoized to prevent unnecessary re-renders
 * Optimized: Added useCallback for click handler
 */
const SubMenuItem = React.memo(({ item, isActive, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(item);
  }, [item, onClick]);

  return (
    <li className="relative">
      <Link
        to={item.to}
        onClick={handleClick}
        style={{
          display: 'block',
          height: '2.938rem',
          background: isActive ? 'rgba(57, 1, 255, 0.08)' : '#fff',
          fontFamily: 'Maven Pro, sans-serif',
          fontWeight: 500,
          fontSize: '0.96rem',
          lineHeight: '1.188rem',
          color: isActive ? '#3901ff' : '#2b2b2b',
          padding: '0.938rem 3.625rem',
          textDecoration: 'none',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = 'rgba(57, 1, 255, 0.08)';
            e.currentTarget.style.color = '#3901ff';
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.background = '#fff';
            e.currentTarget.style.color = '#2b2b2b';
          }
        }}
      >
        <span className="truncate">{item.title}</span>
      </Link>
    </li>
  );
});

SubMenuItem.displayName = 'SubMenuItem';

SubMenuItem.propTypes = {
  /** Sub-menu item configuration */
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }).isRequired,

  /** Whether this item is currently active */
  isActive: PropTypes.bool,

  /** Callback when item is clicked */
  onClick: PropTypes.func.isRequired,
};

SubMenuItem.defaultProps = {
  isActive: false,
};

export default SubMenuItem;
